function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import useTheme from '../use_theme';
export default function withTheme(WrappedComponent) {
  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  // eslint-disable-next-line no-restricted-syntax
  var WithThemeHOC = /*#__PURE__*/React.forwardRef((props, ref) => {
    var theme = useTheme();
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      ref: ref,
      theme: theme
    }));
  });
  WithThemeHOC.displayName = "withTheme(".concat(displayName, ")");

  // See https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(WithThemeHOC, WrappedComponent);
  return WithThemeHOC;
}